import { defineStore } from "pinia";
import { ref } from "vue";
import { useToast } from "vue-toastification";
import integrationService from "@/services/integration";

export const useIntegrationsStore = defineStore("integrations", () => {
  const toast = useToast();
  const loading = ref(false);

  async function fetchIntegrations(companyId) {
    loading.value = true;
    try {
      const res = await integrationService.getIntegrations(companyId);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function fetchIntegrationJobs(companyId) {
    loading.value = true;
    try {
      const res = await integrationService.getIntegrationJobs(companyId);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function addStoreVensafeByToken(payload) {
    loading.value = true;
    try {
      const res = await integrationService.addStoreVensafeByToken(payload);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function createIntegration(payload) {
    loading.value = true;
    try {
      const res = await integrationService.createIntegration(payload);
      toast.success(res.message);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  return {
    loading,
    fetchIntegrations,
    fetchIntegrationJobs,
    addStoreVensafeByToken,
    createIntegration,
  };
});
